// Papel de quem esta logado no painel (Onda 5b). O token do DIRETOR nao tem "nivel": tudo segue igual para ele.
// Para o GESTOR: menu reduzido, saida automatica apos 1 hora sem uso e volta ao login se a sessao acabar.
import { useEffect } from 'react';
import axios from 'axios';
import api from './api';

const NIVEIS_EQUIPE = ['gestor', 'corretor'];
const CHAVE_USO = 'ica_ultimo_uso';
const LIMITE_MS = 60 * 60 * 1000;

export function dadosDoToken() {
  try {
    const t = localStorage.getItem('token') || '';
    const parte = t.split('.')[1];
    if (!parte) return null;
    const b = parte.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(atob(b + '==='.slice((b.length + 3) % 4)).split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
    return JSON.parse(json);
  } catch (e) { return null; }
}

export function nivelAtual() {
  const p = dadosDoToken();
  return (p && p.nivel) || 'diretor';
}

export function ehEquipe() {
  return NIVEIS_EQUIPE.includes(nivelAtual());
}

export function tokenVencido() {
  const p = dadosDoToken();
  return !!(p && p.exp && p.exp * 1000 < Date.now());
}

export function sairDaSessao(motivo) {
  try { localStorage.removeItem('token'); localStorage.removeItem(CHAVE_USO); } catch (e) { /* ok */ }
  try { if (motivo) sessionStorage.setItem('ica_motivo_saida', motivo); } catch (e) { /* ok */ }
  window.location.assign('/admin/login');
}

let _interceptoresProntos = false;
function instalarInterceptores() {
  if (_interceptoresProntos) return;
  _interceptoresProntos = true;
  const aoErro = (error) => {
    if (ehEquipe() && error && error.response && error.response.status === 401) {
      sairDaSessao((error.response.data && error.response.data.detail) || 'Sessão encerrada. Entre novamente.');
    }
    return Promise.reject(error);
  };
  axios.interceptors.response.use((r) => r, aoErro);
  api.interceptors.response.use((r) => r, aoErro);
}

// Usado no menu lateral (aparece em todas as telas do painel). So age para o gestor.
export function useControleSessaoEquipe() {
  useEffect(() => {
    if (!ehEquipe()) return undefined;
    instalarInterceptores();
    if (tokenVencido()) { sairDaSessao('Sessão encerrada. Entre novamente.'); return undefined; }
    const marcar = () => { try { localStorage.setItem(CHAVE_USO, String(Date.now())); } catch (e) { /* ok */ } };
    const ultimo = () => { try { return parseInt(localStorage.getItem(CHAVE_USO) || '0', 10) || 0; } catch (e) { return 0; } };
    if (!ultimo()) marcar();
    let ultimaMarca = 0;
    const aoUsar = () => { const agora = Date.now(); if (agora - ultimaMarca > 15000) { ultimaMarca = agora; marcar(); } };
    const eventos = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    eventos.forEach((e) => window.addEventListener(e, aoUsar, { passive: true }));
    let ultimoPing = Date.now();
    const relogio = setInterval(() => {
      const parado = Date.now() - ultimo();
      if (parado > LIMITE_MS || tokenVencido()) { sairDaSessao('Sessão encerrada por 1 hora sem uso. Entre novamente.'); return; }
      // usando o painel: avisa o servidor a cada 5 min (assim a sessao so cai quando realmente ficar parado)
      if (parado < 5 * 60 * 1000 && Date.now() - ultimoPing > 5 * 60 * 1000) {
        ultimoPing = Date.now();
        api.get('/eu').catch(() => {});
      }
    }, 30000);
    return () => { clearInterval(relogio); eventos.forEach((e) => window.removeEventListener(e, aoUsar)); };
  }, []);
}
